/**
 * the default assumption is that a book is available. See:
 * https://github.com/NYPL-Simplified/Simplified/wiki/OPDS-For-Library-Patrons#opdsavailability---describing-resource-availability
 */
export const DEFAULT_AVAILABILITY = "available";

export const LOGIN_REDIRECT_QUERY_PARAM = "nextUrl";
export const LOGIN_ERROR_QUERY_PARAM = "loginError";
export const REDIRECT_LOGIN_QUERY_PARAM = "access_token";
